import { deepArticles } from "../../../mocks/starTracker";

export default function Insight() {
  return (
    <section id="insight" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 lg:px-10">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700">
              <i className="ri-stack-line text-base"></i>
              深度复盘
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              把热闹拆开看，里面是传播的规律
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              每一篇深度都从一个事件切面切入，讲透道歉、舆情、商务与信息核查背后的公共逻辑。
            </p>
          </div>
          <button
            type="button"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-100 px-4 py-2 text-sm font-semibold text-foreground-800 hover:bg-secondary-200"
          >
            全部专栏 <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {deepArticles.map((a) => (
            <article
              key={a.id}
              className="group flex flex-col overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-40 w-full overflow-hidden sm:h-44">
                <img
                  src={a.image}
                  alt={a.alt}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex whitespace-nowrap rounded-full bg-background-50/95 px-2.5 py-0.5 text-xs font-semibold text-primary-700">
                  {a.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="flex-1 font-heading text-base font-bold leading-snug text-foreground-950">
                  {a.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-3">{a.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="flex items-center gap-1.5 text-xs text-secondary-500 whitespace-nowrap">
                    <i className="ri-time-line"></i>
                    {a.readTime} 阅读
                  </span>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1 text-xs font-semibold text-primary-700 hover:text-primary-600 whitespace-nowrap"
                  >
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}